import React, { useContext } from "react"
import { GameBoardContext } from "../../../context/createContext"
import useReize from "../../../helpers/useResize"
import { MenuLine, BurgerMenuWrapper, BurgerMenuParent } from "../HeaderStyles"

export default function Burger() {
  const { settings, funcs } = useContext(GameBoardContext)
  const { handleSettings, handleSettingsSubpage } = funcs
  const { showSettings, settingsSubpage } = settings
  const { isMobile } = useReize()
  const handleShowSettings = () => {
    showSettings ? handleSettings(false) : handleSettings(true)
  }

  const handleClose = () => {
    if (settingsSubpage === "") {
      handleShowSettings()
      handleSettingsSubpage("Settings")
    } else {
      handleSettingsSubpage("")
      handleSettings(false)
    }
  }

  const isClose =
    settingsSubpage !== "" && (window.innerWidth < 768 || isMobile)

  return (
    <BurgerMenuParent onClick={() => handleClose()}>
      <BurgerMenuWrapper>
        {[...Array(3)].map((e, i) => (
          <MenuLine
            key={i}
            showSettings={(showSettings && !isMobile) || isClose}
          />
        ))}
      </BurgerMenuWrapper>
    </BurgerMenuParent>
  )
}
